import React, { Component, cloneElement, useState } from "react";
import {
  List,
  ExportButton,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  DateField,
  ShowButton,
  Filter,
  TextInput,
  GET_ONE,
  usePermissions,
  useResourceContext,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Spinner from "../../src/spinner";
import myDataProvider from "../myRestProvider";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const ShipTosFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      label="Sold To Name"
      source="business_id"
      reference="businesses"
      linkType="show"
      allowEmpty
    >
      <AutocompleteInput optionText="name"   label="Sold To Name" />
    </ReferenceInput>
    <TextInput source="name" label="Ship To Name" />
    <TextInput source="ship_to_sap_number" label="Ship To ID" />
    <TextInput source="phone" />
  </Filter>
);
class PostPanel extends Component {
  constructor(props) {
    super(props);
    this.fetchItem(props.record.business_id);
    this.reload = this.reload.bind(this);
    this.state = {
      open: false,
      showloader: true,
      reloadButton: false,
      data: {},
      dateFlag: false,
    };
    console.log("id is", props.record.business_id);
    console.log("props is ", props);
  }
  render() {
    return (
      <div className="soldToDetails">
        <table>
          <tr></tr>
          <tr>
            <th>SAP credit area Cd</th>
            <th>Last SAP update</th>
            <th>Currency</th>
            <th>Credit limit</th>
            <th>Credit exposure SAP</th>
            <th>Credit exposure LOGON</th>
            <th>Open credit LOGON</th>
            <th>Orders not invoiced price</th>
            <th>Digital order balance</th>
          </tr>
          <tr>
            <td>{this.state.data.sap_credit_area_cd}</td>
            <td>{this.state.dateFlag && this.state.last_sap_update}</td>
            <td>{this.state.data.currency}</td>
            <td>{this.state.data.credit_limit}</td>
            <td>{this.state.data.credit_exposure_sap}</td>
            <td>{this.state.data.credit_exposure_logon}</td>
            <td>{this.state.data.open_credit_logon}</td>
            <td>{this.state.data.orders_not_invoiced_price}</td>
            <td>{this.state.data.sap_digital_order_balance}</td>
          </tr>
          <tr>
            <td className="errorMsg" colspan="9">
              {this.state.reloadButton && window.navigator.onLine && (
                <div>{this.state.data.msgText}</div>
              )}
            </td>
          </tr>
          <tr>
            <td className="spinner" colspan="9">
              <div className="spinner">
                {this.state.showloader && window.navigator.onLine && (
                  <Spinner />
                )}
              </div>
              {this.state.reloadButton && window.navigator.onLine && (
                <div className="refresh">
                  <i onClick={this.reload} class="material-icons">
                    refresh
                  </i>
                </div>
              )}
              <div>
                {!window.navigator.onLine && (
                  <p>
                    It seems that you are offline. Please check your internet
                    connection
                  </p>
                )}
              </div>
            </td>
          </tr>
        </table>
      </div>
    );
  }

  reload() {
    this.setState(
      {
        reloadButton: false,
        showloader: true,
      },
      () => this.fetchItem(this.props.record.business_id)
    );
  }

  fetchItem = async (id) => {
    const json = await myDataProvider(GET_ONE, "getSapDetails", { id });
    const item = json.data;
    console.log("items are", item);
    this.setState({ showloader: false });
    this.setState({ data: item });
    if (item.errorMsg === "Reload") {
      this.state.reloadButton = true;
    }
    var countryTime = new Date(this.state.data.last_sap_update).toLocaleString(
      "en-US"
    );
    console.log("countryTime", countryTime);
    this.setState({ last_sap_update: countryTime });
    if (this.state.last_sap_update !== "Invalid Date") {
      this.setState({ dateFlag: true });
    }
  };
}

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

// const ListActions = ({ resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
//     return (
//         <TopToolbar>
//             {filters && cloneElement(filters, {
//                 resource,
//                 showFilter,
//                 displayedFilters,
//                 filterValues,
//                 context: 'button',
//             })}
//             <RefreshButton />
//             <ExportButton
//                 disabled={total === 0}
//                 resource={resource + '_csv'}
//                 sort={currentSort}
//                 filter={{ ...filterValues, ...permanentFilter }}
//                 exporter={exporter}
//                 maxResults={maxResults}
//             />
//         </TopToolbar>
//     )
// }

// const ListActions = (props) => {
//     const [modalShow, setModalShow] = React.useState(false);
//     const [modalMsg, setModalMsg] = React.useState('')
//     const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
//     const csvResource = resource + '_csv'
//     const options = CommonHeaderOption();
//     const apiUrl = RUN_TIME_API_ENDPOINT;

//     const callExport = (e) => {
//       e.preventDefault();
//       console.log('...', window.location.href, `${apiUrl}/${resource}_csv`)
//       options.method = 'GET';
//       fetch(`${apiUrl}/${resource}_csv?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D`, options)
//         .then(res => {
//             return res.json();
//         }).then(jsonD => {
//           console.log('jsonD VVVVVVx===>', jsonD.data);
//           const msg = jsonD.data? jsonD.data[0].message : '';
//           setModalShow(true);
//           setModalMsg(msg);
//         });
//     }
//     const exporterModal = () => {
//       return ''
//     }

//     const onClose = () => {
//       setModalShow(false)
//     }
//     return (
//       <React.Fragment>
//       <TopToolbar>
//         {filters && cloneElement(filters, {
//           resource,
//           showFilter,
//           displayedFilters,
//           filterValues,
//           context: 'button',
//         })}
//         <RefreshButton />
//         <ExportButton
//           onClick={(e) => callExport(e)}
//           disabled={total === 0}
//           resource={csvResource}
//           sort={currentSort}
//           filter={{ ...filterValues, ...permanentFilter }}
//           exporter={exporterModal}
//           maxResults={maxResults}
//           />
//       </TopToolbar>
//       {
//             modalShow &&
//             <Modal open={modalShow} onClose={onClose} center>
//               <h3>{modalMsg}</h3>
//             </Modal>
//       }
//       </React.Fragment>
//     )
//   }

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();
  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    location.search
  );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          //   this.setState({ modalShow: true});
          //   this.setState({ modalMsg: msg});
        });
    } else {
      setCustomFilterUrl(
        location.search
      );
      fetch(
        `${apiUrl}/${resource}_csv?${location.search}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          //   this.setState({ modalShow: true});
          //   this.setState({ modalMsg: msg});
        });
    }
  };
  const exporterModal = () => {
    return "";
  };

  const onClose = () => {
    setModalShow(false);
  };
  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        {/* <ExportButton
                    onClick={(e) => this.callExport(e)}
                    disabled={total === 0}
                    resource={csvResource}
                    sort={currentSort}
                    filter={{ ...filterValues, ...permanentFilter }}
                    exporter={this.exporterModal}
                    maxResults={maxResults}
                /> */}
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const ShipTosList = (props) => {
  // state = {
  //     moodalShow: false,
  // }
  // exporter = (data) => {
  //     const msg = data[0].message;
  //     this.setState({
  //         moodalShow: true,
  //         modalMsg: msg,
  //     })
  // }

  // onClose = () => {
  //     this.setState({
  //         moodalShow: false,
  //     })
  // }

  console.log("shiptoooo", props);
  return (
    <React.Fragment>
      <Scrollbars class="scroll-container">
        <List
          sort={{ field: "created_at", order: "DESC" }}
          filters={<ShipTosFilter />}
          title="Ship Tos"
          actions={<ListActions props={props} />}
        >
          <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField label="Ship To ID" source="ship_to_sap_number" />
            <TextField label="Ship To Name" source="name" allowEmpty />
            <TextField source="phone" sortable={false} allowEmpty />
            <ReferenceField
              label="Sold To Name"
              source="business_id"
              reference="businesses"
              link="show"
              allowEmpty
            >
              <TextField source="name" />
            </ReferenceField>
            <TextField
              label="Sold To ID"
              source="retailer_sapcode"
              sortable={false}
            />
            <DateField label={"Created at"} source="created_at" allowEmpty />
            <TextField source="status" />
            <ShowButton />
          </Datagrid>
        </List>
      </Scrollbars>
      {/* {
                    state.moodalShow &&
                    <Modal open={state.moodalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                } */}
    </React.Fragment>
  );
};

export default ShipTosList;
